// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconUnarchive.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconUnarchive = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M13.5377 0.370526L13.3486 1.80211H2.65091L2.4619 0.370526C2.443 0.168421 2.61311 0 2.83991 0H13.1596C13.3864 0 13.5566 0.168421 13.5377 0.370526Z" />
    <path d="M14.9174 3.33474L14.6906 4.76632V4.74947H1.30897L1.06326 3.33474C1.02546 3.13263 1.21446 2.94737 1.44127 2.94737H14.5394C14.7662 2.94737 14.9552 3.13263 14.9174 3.33474Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.6167 5.92842H0.382837C0.15603 5.92842 -0.0329758 6.11368 0.0048254 6.31579L1.80038 15.7137C1.83818 15.8821 1.98939 16 2.17839 16H13.8212C14.0102 16 14.1614 15.8821 14.1992 15.7137L15.9947 6.31579C16.0325 6.11368 15.8624 5.92842 15.6167 5.92842ZM8.15119 9.50792C8.07143 9.41583 7.92857 9.41582 7.84881 9.50792L4.82249 13.0024C4.71032 13.1319 4.80233 13.3333 4.97368 13.3333H11.0263C11.1977 13.3333 11.2897 13.1319 11.1775 13.0024L8.15119 9.50792Z" />
  </BaseIcon>
);

export default IconUnarchive;
